function SelectedTextBoxGridValues(div) {
    var $hiddenValue = $(div + ' input[type = hidden]');
    $hiddenValue.val('');
    $(div + ' input[type=text]').each(function (no, item) {
        var $item = $(item);
        if ($.trim($item.val()) != '') {
            $hiddenValue.val($hiddenValue.val() + '~' + $item.val());
        }
    });
    if ($hiddenValue.val != '') {
        $hiddenValue.trigger('change');
        SetDirtyFlag(true);
    }
}

function SelectedDualTextBoxGridValues(div) {
    var $hiddenValue = $(div + ' input[type = hidden]');
    $hiddenValue.val('');
    var zip = '';
    $(div + ' input[type=text]').each(function (no, item) {
        var $item = $(item);
        if ($item.val() != '') {
            if (no % 2 == 0) {
                zip = $item.val();
            }
            else {
                if (zip != '') {
                    zip = zip + $item.val();
                    $hiddenValue.val($hiddenValue.val() + '~' + zip);
                }
                zip = '';
            }
        }
        else {
            zip = '';
        }
    });
}

function AddTextBoxesToGrid(div, rows, columns) {
    var addTextBoxes = true;
    var $div = $(div);
    $(div + ' input[type=text]').each(function (no, item) {
        if ($.trim($(item).val()) == '') {
            addTextBoxes = false;
            return false;
        }
    });
    var classNames = $(div + ' input[type = text]:last').attr('class');
    if (addTextBoxes) {
        for (i = 0; i < rows; i++) {
            for (j = 0; j < columns; j++) {
                $div.append('<input type="text" class="' + classNames + '" onblur="SelectedTextBoxGridValues(\'' + div + '\');" />');
            }
            $div.append('<br/>');
        }
        InitializeValidators();
    }
}

function AddDualTextBoxesToGrid(div, rows, columns) {
    var addTextBoxes = true;
    var $div = $(div);
    $(div + ' input[type=text]').each(function (no, item) {
        if ($.trim($(item).val()) == '') {
            addTextBoxes = false;
            return false;
        }
    });

    var firstTextBox = $(div + ' input[type = text]:first');
    var secondTextBox = $(div + ' input[type = text]:last');

    var classNames1 = firstTextBox.attr('class');
    var classNames2 = secondTextBox.attr('class');
    var id1 = firstTextBox.attr('id');
    var id2 = secondTextBox.attr('id');
    var onBlurContent = firstTextBox.attr('onblur');

    if (addTextBoxes) {
        for (i = 0; i < rows; i++) {
            for (j = 0; j < columns; j++) {
                $div.append('<input type="text" class="' + classNames1 + '" id="' + id1 + '" onblur="' + onBlurContent + '" />');
                $div.append('<input type="text" class="' + classNames2 + '" id="' + id2 + '" onblur="' + onBlurContent + '" />');
            }
            $div.append('<br/>');
        }
        InitializeValidators();
    }
}

function AddDualTextBoxesToRepeater(div, rows, columns) {
    var addTextBoxes = true;
    var $div = $(div);
    $(div + ' input[type=text]').each(function (no, item) {
        if ($.trim($(item).val()) == '') {
            addTextBoxes = false;
            return false;
        }
    });

    var firstTextBox = $(div + ' input[type = text]:first');
    var secondTextBox = $(div + ' input[type = text]:last');

    var classNames1 = firstTextBox.attr('class');
    var classNames2 = secondTextBox.attr('class');
    var id1 = firstTextBox.attr('id');
    var id2 = secondTextBox.attr('id');
    var onBlurContent = firstTextBox.attr('onblur');

    if (addTextBoxes) {
        for (i = 0; i < rows; i++) {
            for (j = 0; j < columns; j++) {
                $div.append('<input type="text" class="' + classNames1 + '" id="' + id1 + '" onblur="' + onBlurContent + '" />');
                $div.append('<input type="text" class="' + classNames2 + '" id="' + id2 + '" onblur="' + onBlurContent + '" />');
            }
        }
        InitializeValidators();
    }
}

function SelectedDualTextBoxRepeaterValues(div) {

    var $hiddenValue = $(div + ' input[type = hidden]');
    $hiddenValue.val('');
    var zip = '';

    $(div + ' input[type=text]').each(function (no, item) {

        var $item = $(item);

        if ($item.val() != '') {

            if (no % 2 == 0) {
                zip = $item.val();
            }
            else {

                if (zip != '') {

                    zip = zip + ':' + $item.val();
                    $hiddenValue.val($hiddenValue.val() + '~' + zip);
                }
                zip = '';
            }
        }
        else {
            zip = '';
        }
    });
}
